import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const DeliveryFee = ({ deliveryFee }) => {
	const labels = useLabels();

	const getLabeledValue = (label, value) => {
		return labels
			.get(label)
			.replace(/\{\{fee\}\}/, value)
			.trim();
	};

	return (
		<strong>
			{deliveryFee === 0
				? getLabeledValue('DELIVERY_FREE', '')
				: getLabeledValue('DELIVERY_FEE', deliveryFee)}
		</strong>
	);
};

DeliveryFee.propTypes = {
	deliveryFee: PropTypes.number.isRequired
};

export default DeliveryFee;
